import gaTagTracking from './ga-tag-tracking'
import {
  events,
  actions,
  categories,
  settings,
  positions,
  dimensions,
  labels,
  names,
} from './constants'

const analyticsUtils = {
  gaTagTracking,
  events,
  actions,
  categories,
  settings,
  positions,
  dimensions,
  labels,
  names,
}

export default analyticsUtils
